import { createAction, props } from '@ngrx/store';

export const AppInit = createAction('[App] Init', props<{ shopId?: string }>());
